import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import JobRecordStore from '@src/pages/job-record/store';
import Page from '../../components/page';
import Link from '@src/components/link';
import DateUtil from '@src/utils/date-util';
import cx from 'classnames';
const styles = require('./index.less');

const JobRecord = ({ store }) => {
  store.use();

  const renderListContent = () => {
    if (store.list.length > 0) {
      return (
        <div className={styles.listContent}>
          <div className={styles.listTitle}>应聘记录</div>
          <div className={styles.listLabel}>
            <div className={styles.itemJobName}>{store.pageConfig.job_recruitment}</div>
            <div className={styles.line} />
            <div className={styles.itemHireType}>{store.pageConfig.recruitment_type}</div>
            <div className={styles.line} />
            <div className={styles.itemJobLocation}>{store.pageConfig.work_location}</div>
            <div className={styles.line} />
            <div className={styles.itemJobType}>{store.pageConfig.job_type}</div>
            <div className={styles.line} />
            <div className={styles.itemJobNature}>{store.pageConfig.job_nature}</div>
            <div className={styles.line} />
            <div className={styles.itemDate}>{store.pageConfig.delivery_date}</div>
            <div className={styles.line} />
            <div className={styles.itemStatus}>{store.pageConfig.current_state}</div>
          </div>

          <div className={styles.list}>
            {store.list.map((item, index) => {
              // console.log(item.basicInfo.appliedAt);
              // console.log(new Date(item.basicInfo.appliedAt));

              return (
                <div className={styles.listLabel} key={index}>
                  <div className={styles.itemJobName}>{item.jobInfo.title}</div>
                  <div className={styles.line} />
                  <div className={styles.itemHireType}>{item.jobInfo.hireMode === 1 ? '社会招聘' : '校招'}</div>
                  <div className={styles.line} />
                  <div className={styles.itemJobLocation}>{item.jobLocation ? item.jobLocation : '-'}</div>
                  <div className={styles.line} />
                  <div className={styles.itemJobType}>{item.jobInfo.label}</div>
                  <div className={styles.line} />
                  <div className={styles.itemJobNature}>{item.jobInfo.commitment}</div>
                  <div className={styles.line} />
                  <div className={styles.itemDate}>
                    {/* 2021/03/01 */}
                    {item.basicInfo.appliedAt ? DateUtil.formatDate(new Date(item.basicInfo.appliedAt), 'yyyy/MM/dd') : '-'}
                  </div>
                  <div className={styles.line} />
                  <div className={styles.itemStatus}>{store.getStageStatus(item)}</div>
                </div>
              );
            })}
          </div>
          <div className={styles.paginationBox}>
            <Link className={cx(styles.btnPrev, store.currentPage === 0 && styles.disable)} onClick={() => store.clickPrev()}>
              <div className={styles.iconArrowLeft} />
              {store.pageConfig.pre_page}
            </Link>
            <div className={styles.line} />
            <Link className={cx(styles.btnNext, !store.hasNext && styles.disable)} onClick={() => store.clickNext()}>
              {store.pageConfig.next_page}

              <div className={styles.iconArrowRight} />
            </Link>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.notContent}>
          <div className={styles.icon} style={{ backgroundImage: `url("${store.pageConfig.no_records_img}")` }} />
          <div className={styles.tips}>{store.pageConfig.no_records}</div>
          <Link className={styles.btnView} onClick={() => store.goList()}>
            {store.pageConfig.view_position}
          </Link>
        </div>
      );
    }
  };

  const renderContent = () => {
    if (store.isVerify) {
      return renderListContent();
    } else {
      return (
        <div className={styles.notVerify}>
          <div className={styles.icon} style={{ backgroundImage: `url("${store.pageConfig.verify_resume_img}")` }} />
          <div className={styles.tips}>{store.pageConfig.verify_resume}</div>
          <Link className={styles.btnView} onClick={() => store.clickVerify()}>
            {store.pageConfig.verify_text}
          </Link>
        </div>
      );
    }
  };

  return (
    <Page className={styles.root}>
      <div className={styles.kv} />

      <div className={styles.content}>{!store.isLoading && renderContent()}</div>
    </Page>
  );
};

export default wrapStore(JobRecord, JobRecordStore);
